/**
 * User-facing labels for the `/home` landing page.
 * Text only — non-text behavior/config lives in ../config/landingConfig.js.
 */
export const LANDING_LABELS = Object.freeze({
  BRAND: {
    NAME: "ZiniHub",
  },
  HEADER: {
    SIGN_IN: "Sign In",
    CREATE_ACCOUNT: "Create Account",
  },
  HERO: {
    HEADLINE: "Celebrate Freedom of Business with ZiniHub",
    SUBHEADING_LINE_1: "Smart Store Generator for your Business.",
    SUBHEADING_LINE_2: "Be live in minutes",
    OFFER_PERCENT: "0%",
    OFFER_COMMISSION: "Commission",
    OFFER_BENEFITS: Object.freeze(["Free for 6 Months", "0 Setup Cost"]),
    FOOTNOTE:
      "ZiniHub is an e-commerce enablement platform that allows new-age business owners and homepreneurs to launch online storefronts and manage multiple businesses under one Hub.",
    PRIMARY_CTA: "Free Sign Up",
    SECONDARY_CTA: "Contact Us",
    VIDEO_TITLE: "ZiniHub in action",
    VIDEO_BADGE: "Watch how it works",
    VIDEO_UNMUTE: "Unmute video",
    VIDEO_MUTE: "Mute video",
    VIDEO_PAUSE: "Pause video",
    VIDEO_PLAY: "Play video",
  },
  STATUS_CARDS: {
    STORE_LIVE: "Custom Storefront",
    NEW_ORDER: "Orders & Bookings",
    PAYMENT_RECEIVED: "Secured Payment",
    NEW_REVIEW: "In-app chat",
    NEARBY_CUSTOMER: "Get Discovered by Customers",
  },
});
